import React, { useEffect } from "react";
import { hasWindow } from "@litres/utils";

import pubsub from "pubsub";
import { Portal } from "./components/Portal";
import { Overlay } from "./components/Overlay";
import { BottomSheetContent } from "./components/BottomSheetContent";
import { useMountWithTimer } from "./hooks/useMountWithTimer";

export interface BottomSheetProps {
  open: boolean;
  title?: string;
  onClose: (e?: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode;
  wrapperClassName?: string;
  containerClassName?: string;
  contentTestId?: string;
}
export const BottomSheet = (props: BottomSheetProps) => {
  const { open, onClose, children } = props;

  const mounted = useMountWithTimer(open);

  const isShow = hasWindow && mounted;

  useEffect(() => {
    if (isShow) {
      pubsub.publish("helpdeskeddy-hide-widget");
    } else {
      pubsub.publish("helpdeskeddy-show-widget");
    }
  }, [isShow]);

  if (!isShow) {
    return null;
  }

  return (
    <Portal open={mounted} id="bottom-sheet-portal">
      <Overlay open={open} onClose={onClose} />
      <BottomSheetContent {...props}>{children}</BottomSheetContent>
    </Portal>
  );
};
